import { Colors } from "@/enums/Colors";
export const LAZO_POLICY_PAGE = "https://www.lazo.one/privacy-policy";
export const LAZO_TERMS_AND_CONDITIONS_PAGE = "https://www.lazo.one/terms-of-use";
export const DEFAULT_FILE_SIZE_UPLOAD_LIMIT = 100 * 1024 * 1024; // 100 MB
export const ROOMS_FILE_SIZE_UPLOAD_LIMIT = 25 * 1024 * 1024; // 25 MB

// For Quill editor
export const DEFAULT_TOOLBAR_OPTIONS = [
  ["bold", "italic", "underline"],
  ["link"],
  [{ list: "ordered" }, { list: "bullet" }],
  ["clean"],
  [{ color: [Colors.LAZO_PURPLE, Colors.RED, Colors.GREEN_01A902, Colors.BLACK] }],
];

export const DEFAULT_FORMATS = [
  "background",
  "bold",
  "color",
  "font",
  "code",
  "italic",
  "link",
  "size",
  "strike",
  "script",
  "underline",
  "blockquote",
  "header",
  "indent",
  "list",
  "align",
  "direction",
  "code-block",
];
